import script from "./imageCard.vue?vue&type=script&setup=true&lang=js"
export * from "./imageCard.vue?vue&type=script&setup=true&lang=js"

import "./imageCard.vue?vue&type=style&index=0&id=658b1fad&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-658b1fad"]])

export default __exports__